import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangRoIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.13.56A8.982 8.982 0 0 0 9 0a8.98 8.98 0 0 0-3.13.56L5.087 9l.783 8.44A8.98 8.98 0 0 0 9 18a8.98 8.98 0 0 0 3.13-.56L12.913 9 12.13.56Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 9A9.003 9.003 0 0 0 12.13.56v16.88A9.004 9.004 0 0 0 18 9Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 9a9.003 9.003 0 0 0 5.87 8.44V.56A9.003 9.003 0 0 0 0 9Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangRoIconmin);
export { ForwardRef as ReactComponent };
